import {call, put, takeEvery} from "redux-saga/effects";
import CallCenterService from "../services/api/CallCenterService";
import * as types from "../constants/ActionTypes";
import * as actions from "../actions/callCenterActions";

function* fetchCustomer({payload}) {
  try {
    const userVehicle = yield call(CallCenterService.getCustomerVehicleByVin, payload);
    yield put(actions.fetchCustomerSuccess(userVehicle.body));
  } catch (error) {
    yield put(actions.fetchCustomerFailure(error));
  }
}

export function* watchFetchCustomer() {
  yield takeEvery(types.FETCH_CUSTOMER_INFORMATION, fetchCustomer)
}
